module.exports = require('../../modules/_wks-ext').f('toPrimitive');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/symbol/to-primitive.js
// module id = 142
// module chunks = 0